export enum FlightsSortBy {
  BEST_VALUE = 'BEST_VALUE',
  CHEAPEST = 'CHEAPEST',
  FASTEST = 'FASTEST'
}
